import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { BillingCountry } from '../models/billing-country.model';
import { RestUtils } from './rest-utils';

@Injectable()
export class BillingCountryService {
  private readonly countries$: Observable<BillingCountry[]>;
  private readonly utils = new RestUtils();
  private readonly headers = new HttpHeaders({
    'Content-Type': ['application/json'],
  });

  constructor(http: HttpClient) {
    const url = this.utils.buildUrl('/guest/billing-countries');
    const options = this.utils.getHttpHeaderOptions(this.headers);
    this.countries$ = http.get<BillingCountry[]>(url, options).pipe(shareReplay({ bufferSize: 1, refCount: false }));
  }

  all(): Observable<BillingCountry[]> {
    return this.countries$;
  }
}
